// Wails runtime integration utilities

// Type definitions for Wails functions
declare global {
  interface Window {
    go?: {
      main?: {
        App?: {
          GetUnitsURL: () => Promise<string>
          ReloadConfig: () => Promise<void>
        }
      }
    }
  }
}

// Check if we're running in a Wails environment
export const isWailsEnvironment = (): boolean => {
  return (
    typeof window !== "undefined" &&
    !!window.go &&
    !!window.go.main &&
    !!window.go.main.App
  )
}

// Get units URL from Wails backend config
export const getUnitsURL = async (): Promise<string> => {
  if (!isWailsEnvironment()) {
    throw new Error("Not running in Wails environment")
  }

  try {
    return await window.go!.main!.App!.GetUnitsURL()
  } catch (error) {
    console.error("Failed to get units URL from Wails backend:", error)
    throw error
  }
}

// Reload config from Wails backend
export const reloadConfig = async (): Promise<void> => {
  if (!isWailsEnvironment()) {
    throw new Error("Not running in Wails environment")
  }

  try {
    await window.go!.main!.App!.ReloadConfig()
  } catch (error) {
    console.error("Failed to reload config:", error)
    throw error
  }
}
